import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ab94fb7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customer-details" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "CUSTOMER DETAILS")
], -1))
const _hoisted_3 = { class: "input-group" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col--12 col-sm--6" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col--12 col-sm--12" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col--12 col-sm--12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseInput = _resolveComponent("BaseInput")!
  const _component_BaseCheckbox = _resolveComponent("BaseCheckbox")!
  const _component_BaseSection = _resolveComponent("BaseSection")!

  return (_openBlock(), _createBlock(_component_BaseSection, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_BaseInput, {
                type: "text",
                name: "email",
                label: "Customer e-mail",
                placeholder: "Customer Email",
                hasError: _ctx.v$.customerEmail.$error,
                errors: _ctx.v$.customerEmail.$errors,
                valid: !_ctx.v$.customerEmail.$invalid,
                modelValue: _ctx.v$.customerEmail.$model,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.customerEmail.$model) = $event))
              }, null, 8, ["hasError", "errors", "valid", "modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_BaseCheckbox, {
                id: "sendConfirmation",
                name: "sendConfirmation",
                label: "Check this checkbox to send a confirmation email to the customer",
                modelValue: _ctx.v$.sendConfirmation.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.sendConfirmation.$model) = $event))
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_BaseCheckbox, {
              id: "sendConfirmationCopy",
              name: "sendConfirmationCopy",
              label: "Check this checkbox to send a copy of the confirmation email to the current agent",
              modelValue: _ctx.v$.sendConfirmationCopy.$model,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.sendConfirmationCopy.$model) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}